import { gql, useQuery } from "@apollo/client";
import React from "react";
import styled from "styled-components";
import { Loading } from "../Loading";

const Style = styled.div`
    &.magazine {
        text-align: start;
        background-color: #fff;
        border-radius: 16px;
        overflow: hidden;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        width: 25%;
        &.full {
            width: 100%;
        }
        .image {
            width: 100%;
            padding-top: 140%;
            position: relative;
            border: 1px solid #f1f1f1;
            img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 4px;
            }
        }
        .title {
            font-size: 1.2rem;
            padding: 0 0.5rem;
            flex-grow: 1;
        }
        .download {
            padding: 0.5rem;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            .btn {
                cursor: pointer;
                border: 1px solid #f1f1f1;
                border-radius: 8px;
                font-size: 1rem;
                font-weight: 600;
                text-align: center;
                padding: 0.45rem 1rem 0.65rem;
                color: #000000;
                text-decoration: none;
                white-space: nowrap;
                width: min-content;
                display: flex;
                gap: 12px;
                justify-content: center;
                :hover {
                    background-color: #00000020;
                }
            }
        }
    }
`;

export default function MagsCart({v, i ,language, full = false}) {
    if(language.dir === "ltr"){
        return (
            <Style className={"magazine " + ((full) ? "full" : "")} key={i}>
                <div className="image">
                    <img src={v.Image} alt={v.EnName}/>
                </div>
                {/* <div className="description">
                    {v.Group} #{v.Number}
                </div> */}
                <div className="title">
                    {v.EnName}
                </div>
                <div className="download">
                    <a href={v.File} target={"_blank"} className="btn">
                        download
                    </a>
                </div>
            </Style>
        );
    } else {
        return (
            <Style className={"magazine " + ((full) ? "full" : "")} key={i}>
                <div className="image">
                    <img src={v.Image} alt={v.EnName}/>
                </div>
                {/* <div className="description">
                    {v.Group} #{v.Number}
                </div> */}
                <div className="title">
                    {v.Name}
                </div>
                <div className="download">
                    <a href={v.File} target={"_blank"} className="btn">
                        دانلود
                    </a>
                </div>
            </Style>
        );
    }
    
}
